import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit, OnDestroy {
  isDarkMode = true;
  private themeObserver?: MutationObserver;
  
  // Datos del formulario (sin funcionalidad, solo para mostrar)
  formData = {
    nombre: '',
    email: '',
    asunto: '',
    mensaje: ''
  };

  // Preguntas frecuentes
  faqs = [
    {
      question: '¿Qué formatos de imagen son compatibles?',
      answer: 'Soportamos JPG, PNG y WebP. Puedes subir hasta 100 imágenes en un solo archivo ZIP.'
    },
    {
      question: '¿Puedo usar ImageIA comercialmente?',
      answer: 'Sí, todas las imágenes procesadas pueden ser usadas para proyectos personales y comerciales.'
    },
    {
      question: '¿Cómo funciona el editor de banners?',
      answer: 'El editor te permite crear banners y flyers personalizados con texto, imágenes y formas. Puedes guardar tus proyectos y editarlos más tarde.'
    },
    {
      question: '¿Necesito crear una cuenta para usar el servicio?',
      answer: 'No es necesario crear una cuenta para procesar imágenes individuales. Sin embargo, para subir archivos ZIP y guardar proyectos necesitas iniciar sesión.'
    },
    {
      question: '¿Los proyectos se guardan automáticamente?',
      answer: 'Los proyectos se guardan manualmente. Puedes usar el botón "Guardar" para guardar cambios o "Guardar como Proyecto" para crear un nuevo proyecto.'
    }
  ];

  constructor() { }

  ngOnInit(): void {
    this.detectTheme();
    this.observeThemeChanges();
  }

  ngOnDestroy(): void {
    if (this.themeObserver) {
      this.themeObserver.disconnect();
    }
  }

  private detectTheme() {
    this.isDarkMode = document.body.classList.contains('dark-theme');
  }

  private observeThemeChanges() {
    this.themeObserver = new MutationObserver(() => {
      this.detectTheme();
    });
    
    this.themeObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  onSubmit() {
    // Sin funcionalidad, solo para mostrar el formulario
    console.log('Formulario enviado (sin funcionalidad):', this.formData);
  }
}
